module.exports = __webpack_public_path__ + "img/logo_20.833b28b6.png";